import { useEffect, useState } from "react";

const getScrollTop = (): number => {
  const pageEl = document.querySelector<HTMLElement>(
    ".pdl_component_pagewrapper",
  );
  const mainEl = document.querySelector<HTMLElement>(".pdl_component_main");

  const pageScroll = pageEl?.scrollTop || 0;
  const mainScroll = mainEl?.scrollTop || 0;
  const windowScroll =
    window.scrollY || document.documentElement.scrollTop || 0;

  return Math.max(pageScroll, mainScroll, windowScroll);
};

const useIsScrolled = (threshold = 30): boolean => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hasScrolled = getScrollTop() > threshold;
      setIsScrolled((prev) => (prev === hasScrolled ? prev : hasScrolled));
    };

    handleScroll();

    const options: AddEventListenerOptions = { passive: true };
    const pageEl = document.querySelector<HTMLElement>(
      ".pdl_component_pagewrapper",
    );
    const mainEl = document.querySelector<HTMLElement>(".pdl_component_main");

    pageEl?.addEventListener("scroll", handleScroll, options);
    mainEl?.addEventListener("scroll", handleScroll, options);
    window.addEventListener("scroll", handleScroll, options);

    return () => {
      pageEl?.removeEventListener("scroll", handleScroll);
      mainEl?.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  return isScrolled;
};

export default useIsScrolled;
